module.exports = __webpack_public_path__ + "static/media/masons.b52582a8.jpg";